import * as React from 'react';
import Hidden from './Hidden';

export type Props = {
	children?: React.ReactNode,
	[prop:string]: any
}

export class Desktop extends React.Component<Props> {
	render = () => <Hidden mdDown>{this.props.children}</Hidden>
}

export class Mobile extends React.Component<Props> {
	render = () => <Hidden mdUp>{this.props.children}</Hidden>
}